import { render } from "./NoDataLabel.vue?vue&type=template&id=63b6225a"
import script from "./NoDataLabel.vue?vue&type=script&lang=js"
export * from "./NoDataLabel.vue?vue&type=script&lang=js"

import "./NoDataLabel.vue?vue&type=style&index=0&id=63b6225a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__